import { gql } from "@apollo/client";

export const SET_PERMISSION = gql`
  mutation SetPermissions($input: SetPermissionInput) {
    setPermissions(input: $input) {
      data {
            permission {
                id
                role_id
                created_at
                updated_at
                action {
                    created_at
                    updated_at
                    id
                    name
                    action
                    resource {
                        name
                        menu
                        display
                        created_at
                        updated_at
                        id
                        module {
                            name
                            menu
                            display
                            created_at
                            updated_at
                            id
                        }
                    }
                }
            }
        }
      error {
        code
        field
        message
      }
    }
  }
`;
export const REMOVE_PERMISSIONV = gql`
  mutation RemovePermissionsByRole($role_id: UUID!) {
    removePermissionsByRole(role_id: $role_id) {
      data {
        message
      }
      error {
        code
        field
        message
      }
    }
  }
`;
